module.exports = __webpack_public_path__ + "img/aboutusbac.1b092cf1.png";